import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import { ManageService } from "../services/Services";
import useStore from "../services/store/useStore";
import { setSessionCryptofacil, setUserCryptofacil } from "../services/utils/StorageUtils";
import { getCurrentEnvironment } from "../services/utils/Environments";

export const useLoginConfirmationCode = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [isLoadingConfirmationCode, setIsLoadingConfirmationCode] = useState(false);
    const setUserData = useStore(state => state.setUserData);

    const loginConfirmationCodeCryptofacil = useCallback(async (code, email) => {
        setIsLoadingConfirmationCode(true);
        try {
            const responseLoginConfirmationCode = await ManageService.loginConfirmationCodeCryptofacil(code, email);

            console.log(
                "responseLoginConfirmationCode login confirmacion del codigo hook",
                responseLoginConfirmationCode,
            );

            if (responseLoginConfirmationCode) {
                setSessionCryptofacil(
                    getCurrentEnvironment().apiKeyCryptofacil + "|" + responseLoginConfirmationCode?.token,
                );
                setUserCryptofacil(responseLoginConfirmationCode?.user);
                setUserData(responseLoginConfirmationCode?.user);

                if (params?.platform === "zinli" || params?.platform === "pf") {
                    return navigate(`/cryptofacil/${params.platform}`);
                }
                return navigate("/cryptofacil/home");
            }
        } catch (error) {
            console.log("error confirmacion codigo hook", error);
            toast.error(error.message);
        } finally {
            setIsLoadingConfirmationCode(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isLoadingConfirmationCode, loginConfirmationCodeCryptofacil };
};
